/** Hindi: price drivers, their chips, and what an estimate says about itself. */
export const drivers = {
    "question.surface": "अंदर की दीवारें, बाहर की, या दोनों?",
    "question.floors": "कितनी मंज़िलें हैं?",
    "question.house_type": "फ़्लैट है, स्वतंत्र मकान या विला?",
    "question.finish": "सादा पेंट या टेक्सचर?",
    "question.days_week": "हफ़्ते में कितने दिन?",
    "question.tasks": "कौन सा काम: झाड़ू-पोछा, बर्तन के साथ, या पूरा घर?",
    "question.vehicle": "कौन सी गाड़ी: हैचबैक, सेडान या एसयूवी?",
    "question.points": "कितने पॉइंट (स्विच, नल, दरवाज़े या यूनिट)?",
    "detail.surface": "दीवारें",
    "detail.floors": "मंज़िलें",
    "detail.house_type": "घर का प्रकार",
    "detail.finish": "फ़िनिश",
    "detail.days_week": "हफ़्ते में दिन",
    "detail.tasks": "काम",
    "detail.vehicle": "गाड़ी",
    "detail.points": "पॉइंट",
    "driver.ask.area_sqft": "घर लगभग कितने वर्ग फ़ुट का है?",
    "driver.ask.rooms": "कितने बेडरूम (बीएचके)?",
    "driver.ask.surface": "अंदर की दीवारें, बाहर की, या दोनों?",
    "driver.ask.floors": "कितनी मंज़िलें हैं?",
    "driver.ask.house_type": "फ़्लैट है, स्वतंत्र मकान या विला?",
    "driver.ask.paint_by": "पेंट आप ख़रीदेंगे, या पेंटर लाए?",
    "driver.ask.finish": "सादा पेंट या टेक्सचर?",
    "driver.ask.people": "कितने लोगों का खाना बनाना है?",
    "driver.ask.meals": "दिन में कितनी बार खाना?",
    "driver.ask.days_week": "हफ़्ते में कितने दिन?",
    "driver.ask.frequency": "कितनी बार आना है?",
    "driver.ask.tasks": "कौन सा काम: झाड़ू-पोछा, बर्तन के साथ, या पूरा घर?",
    "driver.ask.hours": "दिन में कितने घंटे?",
    "driver.ask.vehicle": "कौन सी गाड़ी: हैचबैक, सेडान या एसयूवी?",
    "driver.ask.problem": "काम क्या है?",
    "driver.ask.points": "कितने पॉइंट (स्विच, नल, दरवाज़े या यूनिट)?",
    "driver.ask.points.electrician": "कितने स्विच, सॉकेट या फिटिंग?",
    "driver.ask.points.plumber": "कितने नल, पाइप या फिटिंग?",
    "driver.ask.points.carpenter": "कितने सामान, दरवाज़े या फिटिंग?",
    "driver.ask.points.ac_technician": "कितने एसी यूनिट?",
    "driver.value.surface.inside": "अंदर",
    "driver.value.surface.outside": "बाहर",
    "driver.value.surface.both": "दोनों",
    "driver.value.house_type.flat": "फ़्लैट",
    "driver.value.house_type.independent": "स्वतंत्र मकान",
    "driver.value.house_type.villa": "विला",
    "driver.value.paint_by.household": "मैं ख़रीदूँगा",
    "driver.value.paint_by.worker": "पेंटर लाए",
    "driver.value.finish.plain": "सादा",
    "driver.value.finish.texture": "टेक्सचर",
    "driver.value.frequency.daily": "रोज़",
    "driver.value.frequency.alternate_days": "एक दिन छोड़कर",
    "driver.value.frequency.weekly": "हफ़्ते में एक बार",
    "driver.value.tasks.sweep_mop": "झाड़ू-पोछा",
    "driver.value.tasks.sweep_mop_dishes": "बर्तन के साथ",
    "driver.value.tasks.full": "पूरा घर",
    "driver.value.vehicle.hatchback": "हैचबैक",
    "driver.value.vehicle.sedan": "सेडान",
    "driver.value.vehicle.suv": "एसयूवी",
    "driver.value.problem.fan": "पंखा",
    "driver.value.problem.switch": "स्विच",
    "driver.value.problem.light": "लाइट",
    "driver.value.problem.wiring": "वायरिंग",
    "driver.value.problem.leak": "लीकेज",
    "driver.value.problem.tap": "नल",
    "driver.value.problem.blockage": "जाम",
    "driver.value.problem.toilet": "टॉयलेट",
    "driver.value.problem.door": "दरवाज़ा",
    "driver.value.problem.repair": "मरम्मत",
    "driver.value.problem.assembly": "फ़र्नीचर जोड़ना",
    "driver.value.problem.service": "सर्विस",
    "driver.value.problem.gas_refill": "गैस भरना",
    "driver.value.problem.install": "लगाना",
    "driver.value.problem.other": "कुछ और",
    "driver.n.area_sqft": "{count} वर्ग फ़ुट",
    "driver.n.rooms.one": "{count} बेडरूम",
    "driver.n.rooms.other": "{count} बेडरूम",
    "driver.n.floors.one": "{count} मंज़िल",
    "driver.n.floors.other": "{count} मंज़िलें",
    "driver.n.people.one": "{count} व्यक्ति",
    "driver.n.people.other": "{count} लोग",
    "driver.n.meals.one": "{count} बार",
    "driver.n.meals.other": "{count} बार",
    "driver.n.days_week.one": "{count} दिन",
    "driver.n.days_week.other": "{count} दिन",
    "driver.n.hours.one": "{count} घंटा",
    "driver.n.hours.other": "{count} घंटे",
    "driver.n.points.one": "{count} पॉइंट",
    "driver.n.points.other": "{count} पॉइंट",
    "driver.thinking": "एक पल, सोच रहा हूँ क्या पूछूँ…",
    "driver.dont_know": "पता नहीं",
    "driver.noun.area_sqft": "घर का क्षेत्रफल",
    "driver.noun.rooms": "बेडरूम की गिनती",
    "driver.noun.surface": "बाहर की दीवारें",
    "driver.noun.floors": "मंज़िलों की गिनती",
    "driver.noun.house_type": "घर का प्रकार",
    "driver.noun.paint_by": "पेंट कौन ख़रीदे",
    "driver.noun.finish": "फ़िनिश",
    "driver.noun.people": "लोगों की गिनती",
    "driver.noun.meals": "कितनी बार खाना",
    "driver.noun.days_week": "हफ़्ते के दिन",
    "driver.noun.frequency": "कितनी बार आना",
    "driver.noun.tasks": "कौन सा काम",
    "driver.noun.hours": "दिन के घंटे",
    "driver.noun.vehicle": "गाड़ी",
    "driver.noun.problem": "काम क्या है",
    "driver.noun.points": "पॉइंट की गिनती",
    "driver.confidence.high": "काफ़ी पक्का",
    "driver.confidence.medium": "मोटा अंदाज़ा",
    "driver.confidence.low": "बहुत मोटा अंदाज़ा",
    "driver.confidence_line": "कितना पक्का: {level}।",
    "driver.spread": "यह ज़्यादातर {driver} पर निर्भर है।",
    "driver.assumed": "मालूम नहीं था, इसलिए माना गया: {drivers}।",
    "driver.basis.gigsync.one": "GigSync का {count} काम",
    "driver.basis.gigsync.other": "GigSync के {count} काम",
    "driver.basis.rate_card": "{city} रेट कार्ड: {sources}",
    "driver.basis_line": "आधार: {parts}।",
    "driver.no_trade": "GigSync पर {job} के दाम अभी नहीं हैं, और GigSync पर अभी कोई यह काम नहीं करता।",
};
//# sourceMappingURL=drivers.js.map